const KLASOUZYTKI__GROUPS: Array<{ category: string; symbols: { symbol: string; label: string }[] }> = [
	{
		category: "Grunty rolne",
		symbols: [
			{ symbol: "R", label: "grunty orne" },
			{ symbol: "S", label: "sady" },
			{ symbol: "Ł", label: "łąki trwałe" },
			{ symbol: "Ps", label: "pastwiska trwałe" },
			{ symbol: "Br", label: "grunty rolne zabudowane" },
			{ symbol: "Lzr", label: "grunty zadrzewione i zakrzewione na użytkach rolnych" },
			{ symbol: "W", label: "grunty pod rowami" },
			{ symbol: "Wsr", label: "grunty pod stawami" },
		],
	},
	{
		category: "Grunty leśne i zadrzewione",
		symbols: [
			{ symbol: "Ls", label: "lasy" },
			{ symbol: "Lz", label: "grunty zadrzewione i zakrzewione" },
		],
	},
	{
		category: "Grunty zabudowane i zurbanizowane",
		symbols: [
			{ symbol: "B", label: "tereny mieszkaniowe" },
			{ symbol: "Ba", label: "tereny przemysłowe" },
			{ symbol: "Bi", label: "inne tereny zabudowane" },
			{ symbol: "Bp", label: "zurbanizowane tereny niezabudowane" },
			{ symbol: "Bz", label: "tereny rekreacyjno-wypoczynkowe" },
			{ symbol: "K", label: "użytki kopalne" },
		],
	},
	{
		category: "Grunty pod wodami",
		symbols: [
			{ symbol: "Wm", label: "grunty pod morskimi wodami wewnętrznymi" },
			{ symbol: "Wp", label: "grunty pod wodami powierzchniowymi płynącymi" },
			{ symbol: "Ws", label: "grunty pod wodami powierzchniowymi stojącymi" },
		],
	},
	{
		category: "Tereny komunikacyjne",
		symbols: [
			{ symbol: "dr", label: "drogi" },
			{ symbol: "Tk", label: "tereny kolejowe" },
			{ symbol: "Ti", label: "inne tereny komunikacyjne" },
			{ symbol: "Tp", label: "grunty przeznaczone pod budowę dróg/kolei" },
		],
	},
	{
		category: "Pozostałe",
		symbols: [
			{ symbol: "N", label: "nieużytki" },
			{ symbol: "Tr", label: "tereny różne" },
			{ symbol: "E", label: "użytki ekologiczne" },
		],
	},
];

const KLASOUZYTKI__LABELS: Record<string, string> = Object.fromEntries(
	KLASOUZYTKI__GROUPS.flatMap((group) => group.symbols.map(({ symbol, label }) => [symbol, label])),
);

export { KLASOUZYTKI__GROUPS, KLASOUZYTKI__LABELS };
